const Transcript = ($, context) => {

  const $cta = $(".blog-bottom-action--transcript .transcript-cta")

  var self = {
    init: () => {
      $cta.on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).siblings('.transcript-copy').slideToggle()
        $(e.currentTarget).toggleClass('open')

      })
    }
  }

  return self;
}

export default Transcript